import _ from "@/boot/lodash";

/** Axios needs to have a [""] for empty arrays. Tf the empty array will be sent, axios will not pass anything */
export function forceAxiosArray(arr = []) {
  if (!_.isArray(arr) || _.isEmpty(arr)) return [""];
  return arr;
}
